<template>
  <div class="forbidden-page">
    <div class="forbidden-page__content">
      <div class="forbidden-page__title">403</div>
      <div class="forbidden-page__subtitle">Access denied</div>
      <p class="forbidden-page__text">
        You don't have access to this page. Please contact your administrator or
        write to
        <a
          class="forbidden-page__link"
          href="https://bimi-boo.atlassian.net/servicedesk/customer/portal/1/group/59"
          target="_blank"
          rel="noopener noreferrer"
          >Help Desk</a
        >.
      </p>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
.forbidden-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 24px;
  background: var(--Color-Background-bg-color, #fff);

  &__content {
    max-width: 560px;
    text-align: center;
  }
  &__title {
    font-size: 72px;
    font-weight: 800;
    line-height: 1;
    margin-bottom: 16px;
  }
  &__subtitle {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 16px;
  }
  &__text {
    font-size: 16px;
    line-height: 1.5;
    margin-bottom: 12px;
  }
  &__link {
    color: var(--el-color-primary);
    word-break: break-all;
  }
}
</style>
